import { object, string, array } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { language } from 'components/Wizards/schemas/shared/language'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { meta } from '../schemaCommon'

export const FlowM1Schema = ({ generationType }: { generationType: string }) => {
  const PressReleaseDetailsSchema = object({
    topic: topic.meta({
      label: 'What is this press release about?',
      autoFill: true,
      generate: false,
      generationType,
    }),

    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType, autoFill: false }),
  }).meta({
    title: 'Share some basics',
  }) as StepSchema

  const RefinementSchema = object({
    content_type: string()
      .oneOf(['New Product Announcement', 'Event', 'Fundraiser', 'Quarterly Results'])
      .default('New Product Announcement')
      .meta({
        label: "What's the goal of this press release?",
        placeholder: 'Select a content goal',
        oneOfPills: true,
      })
      .transform(safify),
    filename,
    project,
    language: language,
    tone: tone.optional().meta({
      generationType,
      overflow: true,
      label: 'More ways to configure',
    }),
  }).meta({
    title: 'Refine the details',

    submitLabel: 'Next',
  }) as StepSchema

  const MediaSchema = object({
    selected_images: array()
      .of(string())
      .default([])
      .meta({
        skipBackgroundRemoval: true,
        multiSelect: true,
      })
      .transform(safify),
    featured_selected_images: array()
      .of(string())
      .default([])
      .meta({
        skipBackgroundRemoval: true,
        multiSelect: true,
      })
      .transform(safify),
  }).meta({
    title: 'Pick your images',
    submitLabel: 'Generate Press Release',
    fullWidth: true,
  }) as StepSchema

  return {
    meta,
    steps: [PressReleaseDetailsSchema, RefinementSchema, MediaSchema],
  } as MultiStepSchema<ChannelType>
}
